import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styletron-react';
import { staticColors } from '../../const/colors/staticColors';
import { sizes } from '../../const/sizes';
import { Text } from '../Text/Text';
import { Box } from '../layout/Box';
import { getDynamicPinningTableCellBackgroundColor } from './helpers/getDynamicPinningTableCellBackgroundColor';
import { getDynamicPinningTableStickyStyles } from './helpers/getDynamicPinningTableStickyStyles';
const BOTTOM_BORDER_STYLE = `${sizes.dynamicTable.rowBorderThickness} solid ${staticColors.dynamicTableRowDivider}`;
const PINNED_COLUMN_SHADOW = `inset ${sizes.dynamicTable.pinnedColumnShadowOffsetX} ${sizes.dynamicTable.pinnedColumnShadowOffsetY} ${sizes.dynamicTable.pinnedColumnShadowBlurRadius} ${sizes.dynamicTable.pinnedColumnShadowSpreadRadius} ${staticColors.baseShadow}`;
const StyledDynamicPinningTableCell = styled('td', ({ $isPinned, $isPinningEnabled, $isRowHovered, $isFirstUnpinnedColumn, $stickyLeftPx, $isMeasured, $pinnedWidthPx, }) => {
    const stickyStyles = getDynamicPinningTableStickyStyles({
        isPinned: $isPinned,
        isMeasured: $isMeasured,
        stickyLeftPx: $stickyLeftPx,
        pinnedWidthPx: $pinnedWidthPx,
    });
    const backgroundColor = getDynamicPinningTableCellBackgroundColor({
        isPinningEnabled: $isPinningEnabled,
        isPinned: $isPinned,
        isRowHovered: $isRowHovered,
    });
    return {
        borderBottom: BOTTOM_BORDER_STYLE,
        backgroundColor,
        boxShadow: $isFirstUnpinnedColumn ? PINNED_COLUMN_SHADOW : undefined,
        ...stickyStyles,
    };
});
export const DynamicPinningTableCell = ({ children, rowId, CellClickableWrapper, rowData, columnId, isRowHovered, pinningInfo, }) => {
    const content = (_jsx(Box, { spacingVertical: '3/2', spacingHorizontal: true, children: _jsx(Text, { as: 'div', variant: 'b2', children: children }) }));
    const cellContent = CellClickableWrapper ? (_jsx(CellClickableWrapper, { rowData: rowData, rowId: rowId, columnId: columnId, children: content })) : (content);
    return (_jsx(StyledDynamicPinningTableCell, { $isPinned: pinningInfo?.isPinned, $isPinningEnabled: pinningInfo?.isPinningEnabled, $isRowHovered: isRowHovered, $isFirstUnpinnedColumn: pinningInfo?.isFirstUnpinnedColumn, $stickyLeftPx: pinningInfo?.stickyLeftPx, $isMeasured: pinningInfo?.isStickyLeftPxMeasured, $pinnedWidthPx: pinningInfo?.pinnedWidthPx, children: cellContent }));
};
